/* kmy-editorial.js — 2026-09-09
   On article pages: (1) add an "On this page" list built from H2s when there are 4 or more,
   (2) add an estimated reading time next to the date. No dependencies. */
(function () {
  var content = document.querySelector('.article-template__content');
  if (!content) return;

  // Reading time
  try {
    var words = (content.innerText || '').trim().split(/\s+/).length;
    var mins = Math.max(1, Math.round(words / 220));
    var date = document.querySelector('.article-template .circle-divider');
    if (date && !document.querySelector('.kmy-readtime')) {
      var rt = document.createElement('span');
      rt.className = 'kmy-readtime';
      rt.textContent = mins + ' min read';
      date.parentNode.insertBefore(rt, date.nextSibling);
    }
  } catch (e) {}

  // On this page
  try {
    var h2s = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (h2s.length < 4 || content.querySelector('.kmy-toc')) return;
    var used = {};
    var slug = function (t) {
      var s = t.toLowerCase().replace(/[^a-z0-9぀-ヿ一-鿿]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
      var base = s, i = 2;
      while (used[s] || document.getElementById(s)) { s = base + '-' + i++; }
      used[s] = 1;
      return s;
    };
    var nav = document.createElement('nav');
    nav.className = 'kmy-toc';
    nav.setAttribute('aria-label', 'On this page');
    var label = document.createElement('span');
    label.className = 'kmy-toc__label';
    label.textContent = 'On this page';
    var ol = document.createElement('ol');
    h2s.forEach(function (h) {
      var text = (h.textContent || '').trim();
      if (!text) return;
      if (!h.id) h.id = slug(text);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      ol.appendChild(li);
    });
    nav.appendChild(label);
    nav.appendChild(ol);
    h2s[0].parentNode.insertBefore(nav, h2s[0]);
  } catch (e) {}
})();
